import { useCallback } from 'react';
import { usePrompt } from './usePrompt';
export const useConfirm = (when) => {
    const blocker = usePrompt(when);
    const resetConfirmation = useCallback(() => {
        if (blocker.state === 'blocked')
            blocker.reset();
    }, [blocker]);
    const onConfirm = () => {
        if (blocker.state === 'blocked')
            setTimeout(blocker.proceed, 0);
    };
    return {
        isActive: blocker.state === 'blocked',
        onConfirm,
        resetConfirmation,
    };
};
